{
  "version": 1,
  "asset_id": "654837e5-9fb2-400d-83da-419cc4c4cbc7",
  "project_id": "1203040e-940d-4f2e-ab5b-8733ed2d3c31",
  "url": "/__l5e/assets-v1/654837e5-9fb2-400d-83da-419cc4c4cbc7/opt_metodo-6.jpg",
  "r2_key": "a/v1/1203040e-940d-4f2e-ab5b-8733ed2d3c31/654837e5-9fb2-400d-83da-419cc4c4cbc7/opt_metodo-6.jpg",
  "original_filename": "opt_metodo-6.jpg",
  "size": 85510,
  "content_type": "image/jpeg",
  "created_at": "2026-08-26T20:33:45Z"
}
